<template lang="pug">
.content
  ed-title-nav(title='Settings')
  .container-fluid
    ed-section.active
      ed-card(v-for='(setting, index) in settings'
        :key='setting.name'
        :title='setting.name'
        :subtitle='setting.description'
        :footer-button='setting.configurable'
        :icon='setting.icon'
      )
        ed-switch(v-model='setting.status' slot='top')
        div(slot='footer')
          ed-button(@click='edit'
            v-if='setting.configurable != "false"'
            :disabled='!setting.status'
            button-class='btn btn-actionbar'
          ) {{setting.configurable}}
</template>

<script>

export default {
  name: 'Settings',

  data () {
    return {
      settings: [
        {name: 'Cost Centers', status: true, description: 'Set up and configure cost centers for funding allocations.', configurable: 'Configure', new: false, icon: ['fas', 'user']},
        {name: 'Divisions', status: true, description: 'Set up division for reporting and purchase order and expense work flow.', configurable: 'Configure', new: false, icon: []},
        {name: 'Expenses', status: true, description: 'Set up preferences and threshholds within the approval work flow.', configurable: 'Configure', new: false, icon: ['fal', 'credit-card']},
        {name: 'Invoices', status: true, description: 'Set up invoice preferences for approvals, terms and rush payments.', configurable: 'Configure', new: false, icon: ['far', 'file-alt']},
        {name: 'Partners', status: true, description: 'Set up partners for funding allocations.', configurable: 'Configure', new: false, icon: ['far', 'handshake']},
        {name: 'Purchase Orders', status: true, description: 'Set up terms, preferences and thresholds within the approval work flow', configurable: 'Configure', new: false, icon: ['far', 'shopping-cart']},
        {name: 'Sub-Categories', status: false, description: 'Create and manage custom sub categories.', configurable: 'Configure', new: false, icon: ['fal', 'list-alt']},
        {name: 'Something', status: false, description: 'This setting has no configurations but can be turned on and off.', configurable: 'false', new: true, icon: ['fal', 'question-circle']}
      ]
    }
  },

  methods: {
    edit () {
      var id = this.id
      this.$emit('edit', id)
    }
  }
}
</script>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// settings.vue?eeb18052